import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AFichaInformativa, FichasInformativasModel, SeccionPrincipal } from '../models/ficha-informativa.model';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({providedIn: 'root'})
export class FichasInformativasService {
  private serverUrl = environment.serverUrl;
  public fichasInformativas: FichasInformativasModel;

  constructor(private http: HttpClient) { }

  ObtenerFichasInformativas():Observable<FichasInformativasModel|null> {
    try{
      return this.http.post<any>(`${this.serverUrl}fichas-informativas`, {})
        .pipe(
          map( response => {
            if(!response || !response.data) throw new Error("Error cargando las fichas informativas")
            this.fichasInformativas = {
              seccionPrincipal: response.data.seccionPrincipal as SeccionPrincipal,
              fichas: [
                response.data.primeraFichaInformativa as AFichaInformativa,
                response.data.segundaFichaInformativa as AFichaInformativa,
                response.data.terceraFichaInformativa as AFichaInformativa,
                response.data.cuartaFichaInformativa as AFichaInformativa,
              ]
            }
            return this.fichasInformativas
          })
        )
    }catch( error ) {
      console.log('Error cargando las fichas informativas => ', error)
    }
  }
}
